
    import particlesPackage from 'particles.js/particles';
    import { $qs, $qsa } from '../../utils/QuerySelector';
    import gsap from 'gsap';
    
    function servicesTabs() {
    
        const tabsContain = $qsa('[data-name="services-tabs"]');
    
        if (!tabsContain) return;

    const tabs = document.querySelectorAll('[role="tab"]');
    const tabList = document.querySelector('[role="tablist"]');

    if (tabs) {
      // Add a click event handler to each tab
      tabs.forEach((tab) => {
        tab.addEventListener("click", function (e) {
          changeTabs(e.currentTarget);
        });
      });

      // Enable arrow navigation between tabs in the tab list
      let tabFocus = 0;

      if (tabList) {
        tabList.addEventListener("keydown", (e) => {
          // Move right
          if (e.keyCode === 39 || e.keyCode === 37) {
            tabs[tabFocus].setAttribute("tabindex", -1);
            if (e.keyCode === 39) {
              tabFocus++;
              // If we're at the end, go to the start
              if (tabFocus >= tabs.length) {
                tabFocus = 0;
              }
              // Move left
            } else if (e.keyCode === 37) {
              tabFocus--;
              // If we're at the start, move to the end
              if (tabFocus < 0) {
                tabFocus = tabs.length - 1;
              }
            }

            tabs[tabFocus].setAttribute("tabindex", 0);
            tabs[tabFocus].focus();
          }
        });
      }

    
    }
}

function changeTabs(target) {
    //control container - find tablist
    const controlList = target.closest('[role="tablist"]');

    const targetID = target.getAttribute("aria-controls");
    const lastIndex = targetID.lastIndexOf("-");
    const allContentSelector = targetID.slice(0, lastIndex);
    const contentList = document.querySelectorAll(
      '[id^="' + allContentSelector + '"]'
    );

        // Remove all current selected tabs
        controlList.querySelectorAll('[aria-selected="true"]').forEach((t) => {
            t.setAttribute("aria-selected", false);
            t.classList.remove("opacity-100");
            t.classList.add("opacity-30");
          });
  
          // Set this tab as selected
          target.setAttribute("aria-selected", true);
          target.classList.add("tab-active");
          target.classList.remove("opacity-30");
          target.classList.add("opacity-100");

    // Hide all tab panels
    contentList.forEach((p) => p.setAttribute("hidden", true));

    // Show the selected panel
    const selectedPanel = document.querySelector(`#${targetID}`);
    selectedPanel.removeAttribute("hidden");

    let tl = gsap.timeline({});
    tl.to(contentList, { autoAlpha: 0, duration: 0.3 })
      .set(contentList, { height: 0 })
      .set(selectedPanel, { height: "auto" })
      .to(selectedPanel, { autoAlpha: 1, duration: 0.3 });
  }


export default servicesTabs;